/**
 * Task Card Component
 * Renders a task using the appropriate template based on actionType
 *
 * @module pages/tasks/components/TaskCard
 */

import logger from '@/utils/logger';
import { getTaskTemplateComponent } from './templates';
import type { TaskCardProps } from '../types';

export function TaskCard({ task, onComplete, onDismiss, onDelete, isUpdating, debugMode, isSelected, onRef }: TaskCardProps) {
  const TemplateComponent = getTaskTemplateComponent(task.actionType);

  return (
    <div
      ref={onRef}
      className={`rounded-lg transition-all ${isSelected ? 'ring-2 ring-primary ring-offset-2 ring-offset-surface-1' : ''}`}
    >
      <TemplateComponent
        task={task}
        onNavigate={() => {
          logger.info('Tasks', 'Navigating to task target', { taskId: task.id, targetUrl: task.targetUrl });
        }}
        onComplete={() => onComplete(task.id)}
        onDismiss={() => onDismiss(task.id)}
        onDelete={() => onDelete(task.id)}
        isUpdating={isUpdating}
        debugMode={debugMode}
      />
    </div>
  );
}
